import { useEffect , useState } from 'react'
import { useStore } from 'store'
import { hideLoader, showLoader } from 'store/actions/commons'
import { BASE_PATH_API } from 'constants/env'
import iconPhone from 'assets/img/phoneIcon.png'
import styles from '../styles.module.sass'

const ModulePhone = (props) => {
    const {
        handleClose,
        event_ID,
        successPhone
    } = props

    const [ , dispatch ] = useStore((state) => state.giftTable.giftTable)
    const [ phoneVal, setPhoneVal ] = useState('')
    const [ phoneService, setPhoneService ] = useState(null)
    const [ flagDisable, setFlagDisable ] = useState(true)
    const [ errorMessage , setErrorMessage ] = useState(null)

    const putPhoneRegistration = async (eventID, phoneNumber) => {
        dispatch(showLoader());
        setErrorMessage(null)
        const idsFilter = String(eventID)
        try {
            const payload = {
                phone_number: String(phoneNumber)
            }

            const header = {
                method: 'PUT',
                headers: { 'Content-Type':'application/json' },
                body: JSON.stringify(payload)
            }

            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table/${idsFilter}/wallet-registration`, header);
            const data = await response.json();
            setPhoneService(data)
        } catch (error) {
            dispatch(hideLoader());
            console.error('Error fetching getEventTable data:', error);
        }
    }

    const changePhone = (event) => {
        const input = event
        const telephone = input.trim()
        const phoneRegex = /^\d+$/

        if (phoneRegex.test(telephone)) {
            return telephone
        }
    }


    const handleSubmit = (event) => {
        event.preventDefault()
        if(phoneVal?.length === 10){
            if(event_ID){
                putPhoneRegistration(event_ID, phoneVal)
            }
        }
    }

    const handleChange = (event) => {
        const { value } = event.target
        setErrorMessage(null)
        if(value === ''){
            setPhoneVal( value)
            setFlagDisable(true)
        }else if(changePhone(value)){
            if(String(value).length <= 9 ){
                setFlagDisable(true)
                setPhoneVal( changePhone(value))
            }else if(String(value).length === 10 ){
                setPhoneVal( changePhone(value))
                setFlagDisable(false)
            }
        }
    }

    useEffect(()=>{
        if(phoneService){
            dispatch(hideLoader());
            if(phoneService?.metadata?.http_status <= 202){
                successPhone(phoneVal)
            }else if(phoneService?.metadata?.http_status === 400){
                setErrorMessage(phoneService?.data[0])
                // console.log('error marcado: ', phoneService?.data[0])
            }
        }
    },[phoneService])

    return(
        <div className={styles?.contModal}>
            <div className={styles?.closeBtn} onClick={handleClose} aria-hidden>X</div>
            <form onSubmit={handleSubmit}>
                <img src={iconPhone} alt="icon" className={styles?.iconPhone} />
                <h1 className={styles?.titlePhone}>Verificación OTP</h1>
                <p className={styles?.subTitlePhone}>Para ver tu monedero SEARS primero necesitmos asociar tu teléfono móvil.</p>
                <label
                    htmlFor='phone'
                    className={styles?.contInputPhone}
                >
                    <span className={styles?.labelPhone}>Ingresa los 10 números de tu teléfono móvil. </span>
                    <span className={styles?.inputStyle}>
                        <input 
                            type="text"
                            name='phone'
                            id='phone'
                            className={errorMessage ? `${styles?.errorMessageInput} ${styles?.inputPhone}` : styles?.inputPhone}
                            value={phoneVal}
                            onChange={handleChange}
                        />
                    </span>
                </label>
                {errorMessage
                    ?  <p className={styles?.errorMessageText}>{errorMessage}</p>
                    : null
                }
                <p className={styles?.subTitlePhone}>Te enviaremos un SMS con un código de 6 digitos que necesitarás para poder asociar tu teléfono móvil.</p>

                <button
                    type="submit"
                    className={`${styles?.buttonSuccess} btn primaryButton`}
                    disabled={flagDisable}
                >Enviar SMS</button>
            </form>
        </div>
    )
}

export default ModulePhone